//core
import React from "react";
import { Box } from "@mui/material";

//types
import { ITableData } from "../../../../../../../store/admin/flatFee";

//components
import MobilePagination from "../../../../../../common/MobilePagination";
import ItemCard from "./components/ItemCard";
import EmptyTable from "../../../../../../common/TableData/components/EmptyTable";

interface IMobileListProps {
  data: ITableData;
  currentPage: number;
  setPage: (event: unknown, newPage: number) => void;
}

const MobileList: React.FC<IMobileListProps> = ({
  data,
  currentPage,
  setPage,
}): JSX.Element => {
  return (
    <>
      <Box>
        {data.list.map((item) => <ItemCard key={item.id} data={item} columns={data.columns} />)}
      </Box>

      {!data.list.length && <EmptyTable />}

      {!!data.list.length && (
        <MobilePagination
          currentPage={currentPage}
          lastPage={data.totalPages}
          setPage={setPage}
          total={{
            end_row_num: data.endRowNum,
            start_row_num: data.startRowNum,
            total_entries: data.totalEntries,
          }}
        />
      )}
    </>
  );
};

export default MobileList;
